import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-sanjiaoshang",
  "use": "icon-sanjiaoshang-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-sanjiaoshang\"><defs><style type=\"text/css\"></style></defs><path d=\"M27.273 753.613l485.222-484.233 484.233 485.222z\" p-id=\"7913\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol